





















































































































import { PropType } from 'vue';
import { mapActions, mapGetters } from 'vuex';

import mixins from '@/utils/mixins';
import formRules from '@/mixins/file-upload-rules';
import snackbar from '@/mixins/snackbar';

import { IQuote } from '@/models';
import { ErrorManager } from '@/models/error';
import { createFile } from '@/utils/helpers';
import DragDropFileInput from '../common/DragDropFileInput.vue';
import ErrorAlert from '../common/ErrorAlert.vue';
import { ALForm } from '@/common/component.types';
import { IQuoteUploadRFQAttachmentActionPayload } from '@/store/quote';

const baseMixins = mixins(snackbar, formRules);
export interface Options extends InstanceType<typeof baseMixins> {
  $refs: {
    form: ALForm;
  };
}

export default baseMixins
  .extend<Options>({
    functional: false
  })
  .extend({
    name: 'QuoteRFQAttachmentListItem',

    components: { DragDropFileInput, ErrorAlert },

    props: {
      quote: Object as PropType<IQuote>
    },

    data() {
      return {
        menu: false,
        loading: false,
        fileLoading: false,
        isFileValid: false,
        file_upload: null as File | null,
        errorMessage: '',
        detailErrorMessage: ''
      };
    },

    computed: {
      ...mapGetters({
        getQuoteByIdAndRevision: 'quote/getQuoteByIdAndRevision'
      })
    },

    methods: {
      ...mapActions({
        downloadRfqAttachment: 'quote/downloadRfqAttachment',
        uploadRfqAttachment: 'quote/uploadRfqAttachment'
      }),

      clearAllErrors() {
        this.errorMessage = '';
        this.detailErrorMessage = '';
      },

      downloadQuoteRFQAttachment(quote: IQuote) {
        this.clearAllErrors();
        this.loading = true;

        this.downloadRfqAttachment(quote.number)
          .then(data => {
            createFile(data, quote.rfq_attachment!);
          })
          .then(() => {
            this.createSnack({
              color: 'success darken-1',
              type: 'download',
              right: true,
              useBtn: false,
              msg: `Downloaded file: '${quote.rfq_attachment}'`,
              btnText: 'Close'
            });
          })
          .catch(error => {
            this.errorMessage = ErrorManager.extractApiError(error);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      validateForm(): boolean {
        let valid = false;
        if (this.$refs.form) {
          valid = this.$refs.form.validate();
        }
        return valid;
      },

      close() {
        this.menu = false;
      },

      uploadFile() {
        if (this.validateForm()) {
          this.clearAllErrors();
          this.fileLoading = true;

          const payload: IQuoteUploadRFQAttachmentActionPayload = {
            number: this.quote.number!,
            file_upload: this.file_upload as File
          };

          this.uploadRfqAttachment(payload)
            .then(() => {
              this.file_upload = null;

              // to avoid callback change in quote detail set visual rqf_attachment here
              const quote = this.getQuoteByIdAndRevision(
                this.quote.number,
                this.quote.revision
              );
              (this.$refs.rfq_attachment as any).save(quote.rfq_attachment);

              this.$emit('change');
              this.close();
            })
            .catch(error => {
              if (error.response) {
                // client received an error response that falls out of range 2xx
                if (error.response.data.detail) {
                  this.detailErrorMessage = error.response.data.detail;
                }
              }

              this.errorMessage = ErrorManager.extractApiError(error);
            })
            .finally(() => {
              this.fileLoading = false;
            });
        }
      }
    }
  });
